import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import ShareModal from "@features/Perspective/components/ShareModal";

let mounted = false;

function mount() {
  if (typeof document === "undefined") return;
  if (mounted) return;
  const container = document.createElement("div");
  container.id = "global-share-modal-root";
  document.body.appendChild(container);
  const root = ReactDOM.createRoot(container);

  const AppWrapper: React.FC = () => {
    const [show, setShow] = useState(false);
    const [perspectiveId, setPerspectiveId] = useState<string | null>(null);

    React.useEffect(() => {
      // Expose global opener
      (window as any).openPerspectiveShare = (id: string) => {
        setPerspectiveId(id);
        setShow(true);
      };

      // Do not overwrite `handleExport` to avoid breaking test spies or existing instrumentation.
      // Tests may spy on `window.handleExport`; we preserve it and instead expose
      // `openPerspectiveShare` and `notifyPerspectiveShare`. Components that call
      // `handleExport` will still call the original function and any test spies.

      // Also expose a helper used by lightweight instrumentation
      (window as any).notifyPerspectiveShare = (payload: any) => {
        try {
          if (payload && (payload.perspective_id || payload.perspectiveId)) {
            const id = payload.perspective_id || payload.perspectiveId;
            (window as any).openPerspectiveShare(id);
          }
        } catch (e) {}
      };

      // Poll for legacy `window.dataFlow.perspectiveShare` marker (some components/tests set this)
      const poll = setInterval(() => {
        try {
          const df = (window as any).dataFlow;
          if (df && df.perspectiveShare) {
            const payload = df.perspectiveShare;
            const id = payload?.perspective_id || payload?.perspectiveId;
            if (id) {
              (window as any).openPerspectiveShare(id);
            }
            // clear to avoid re-opening
            try {
              delete (window as any).dataFlow.perspectiveShare;
            } catch {}
          }
        } catch (e) {}
      }, 300);

      return () => {
        clearInterval(poll);
        // cleanup: restore handleExport if needed
        // Not restoring orig to avoid surprising tests, but could be added
      };
    }, []);

    return (
      <ShareModal
        show={show}
        onHide={() => setShow(false)}
        perspectiveId={perspectiveId}
        onShared={() => setShow(false)}
      />
    );
  };

  root.render(React.createElement(AppWrapper));
  mounted = true;
}

export function ensureShareModalMounted() {
  try {
    mount();
  } catch {
    // non-fatal: DOM not ready yet
  }
}

// Auto-mount if window is already ready
if (typeof window !== "undefined" && document.readyState === "complete") {
  ensureShareModalMounted();
}
